import { useTranslation } from 'react-i18next';
import PersonalInfoSection from '@/components/account/PersonalInfoSection';
import PhoneSection from '@/components/account/PhoneSection';
import PasswordSection from '@/components/account/PasswordSection';
import NotificationPreferencesSection from '@/components/account/NotificationPreferencesSection';
import QuickLinksSection from '@/components/account/QuickLinksSection';

/**
 * Customer self-service account page. Five stacked cards:
 *
 * <ol>
 *   <li>Personal info (Sprint 7 Evening 10) — name + locale.</li>
 *   <li>Phone (Sprint 7 Evening 8) — Twilio Verify flow.</li>
 *   <li>Password (Sprint 7 Evening 10) — current/new/confirm.</li>
 *   <li>Notification preferences (Sprint 7 Evening 10) — per-type
 *       email + SMS toggles, SMS gated by phone verification.</li>
 *   <li>Quick links (Sprint 7 Evening 10) — bookings + venues.</li>
 * </ol>
 */
export default function AccountPage() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto max-w-2xl px-4 py-8 md:px-6 md:py-10">
      <header>
        <p className="text-xs font-mono uppercase tracking-[0.18em] text-neutral-400">
          {t('account.your_account')}
        </p>
        <h1 className="mt-1 text-2xl font-semibold tracking-tight text-neutral-900 md:text-3xl">
          {t('account.title')}
        </h1>
        <p className="mt-1 text-sm text-neutral-500">{t('account.subtitle')}</p>
      </header>

      <div className="mt-6 flex flex-col gap-4">
        <PersonalInfoSection />
        <PhoneSection />
        <PasswordSection />
        <NotificationPreferencesSection />
        <QuickLinksSection />
      </div>
    </div>
  );
}
